export default __webpack_public_path__ + "static/media/p33.30dfb668.jpg";